module.exports = __webpack_public_path__ + "officialStatic/img/detail-two-bg.a301362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-two-bg.png
// module id = 7mqa
// module chunks = 0